import ColorBox from "../components/collection/ColorBox";
import { EditBox, AddToList, DeleteSvg } from "./Icon";

export const iconsMap = {
    color: <ColorBox />,
    loading: '',
    edit: <EditBox />,
    create: <AddToList />,
    delete: <DeleteSvg />,
};